<header class="col-12 header-page">
  <h1 class="header__page__content__title">
    Atas de Governança
  </h1>
</header>
<main class="main__content">
  <form [formGroup]="formData">
    <section class="row content__form">
      <div class="px-1 col-xl-4 col-lg-6 col-md-4 col-sm-12 pt-0">
        <label class="label-form">Selecione um grupo *</label>
        <ng-select class="ng-pristine" bindLabel="grupo" bindValue="grupo" id="ngSelect" placeholder="Selecione"
          (close)="yearChanged();loadYears();" formControlName="grupo" [items]="items" [searchable]="false">
        </ng-select>
        <small class="form-text text-muted danger ng-pristine"
          *ngIf="formData.get('grupo')?.touched && formData.get('grupo')?.invalid">
          Por favor, selecione um grupo
        </small>
      </div>
      <div class="px-1 col-xl-4 col-lg-6 col-md-4 col-sm-12 pt-0 pt-md-0"
        *ngIf="listaAnos != null && formData.get('grupo')">
        <label class="label-form">Selecione um ano *</label>
        <ng-select class="ng-pristine" bindLabel="ano" id="ngSelect" placeholder="Selecione" (close)="yearChanged()"
          formControlName="ano" [items]="listaAnos.anos" [searchable]="false">
        </ng-select>
        <small class="form-text text-muted danger ng-pristine"
          *ngIf="formData.get('ano')?.touched && formData.get('ano')?.invalid">
          Por favor, selecione o campo ano
        </small>
      </div>
    </section>
    <button class="btn btn-primary mt-2 col-xl-2 col-lg-3 col-md-4 col-sm-12" (click)="getFilter()"
      [disabled]="this.loading" *ngIf="formData.get('grupo')?.value != null && formData.get('ano')?.value != null">
      <div class="spinner-border" role="status" *ngIf="loading; else showSpan" [@fadeInOut]>
        <span class="sr-only">Consultando</span>
      </div>
      <ng-template #showSpan>
        <span>Consultar</span>
      </ng-template>
    </button>
  </form>
  <section *ngIf="pesquisa">
    <section class="content__header mt-4">
      <h4>
        Documentos - {{formData.get('grupo')?.value}} ({{formData.get('ano')?.value}})
      </h4>
      <filtro-dados [pageItens]="5" [totalItens]="listaArquivos.totalFiltered"
        (changeQuantidade)="onChangeQuantidadeItens($event)" *ngIf="pesquisa">
      </filtro-dados>
    </section>
    <section class="content__main">
      <div class="d-flex content__header__table">
        <div class="col-xl-7">Arquivo</div>
        <div class="col-xl-3">Grupo</div>
        <div class="col-xl-2 column-acoes">Ações</div>
      </div>
      <div class="table__card" *ngFor="let ata of listaArquivos?.items">
        <div class="col-xl-7 table__card__title">
          {{ ata.filename | removeExtensao}}
        </div>
        <div class="col-xl-3 table__card__title">
          {{ ata.grupo }}
        </div>
        <div class="col-xl-2 table__card__button__action column-acoes">
          <fa-icon [icon]="faEye" (click)="visualizarAta(ata.id, ata.filename)"></fa-icon>
        </div>
      </div>
    </section>
  </section>
  <footer class="col-12 footer__content">
    <paginacao [currentPage]="formData.value.page" [collectionSize]="listaArquivos.totalFiltered"
      [pageSize]="formData.value.itemsPerPage" (changeNumber)="onChangePagination($event)" *ngIf="pesquisa">
    </paginacao>
  </footer>
</main>